module.exports = __webpack_public_path__ + "img/24.d1567826.png";